// FUNNEL VUEX MUTATIONS
import Vue from 'vue';
import {
   CUSTOM_FIELD_HANDLE_NUMBER_OF_PEOPLE,
   CUSTOM_FIELD_HANDLE_DELIVERY_DATE,
} from '@/js/global/config';
import {
   DISCOUNT_ADJUSTER_TYPE,
   SHIPPING_ADJUSTER_TYPE,
   TAX_ADJUSTER_TYPE,
   MENUS_PRODUCT_TYPE,
} from '@/js/funnel/_config/commerce';
import {getSummaryItemObject} from '@/js/funnel/_config/funnel';

const calculateTaxes = (state) => {
   // reset all taxes totals.
   for(const taxType in state.summary.tax) {
      state.summary.tax[taxType].total = 0
   }
   state.summary.adjustments[TAX_ADJUSTER_TYPE] = []

   let taxRate = 0;
   let totalTax = 0;
   let untaxedItems = [];
   // Index discounts in order to subtract them to their related item net price
   let discounts = {}
   for (let adjuster of state.summary.adjustments[DISCOUNT_ADJUSTER_TYPE]) {
      discounts[adjuster.lineItemId] = adjuster
   }
   // add up the total below for the Selection page
   for (let productType in state.summary.lineItems) {
      // if this is the package menu, add its data
      if (productType === MENUS_PRODUCT_TYPE) {
         if(state.menu.isALaCarte) {
            continue;
         }

         if(!state.summary.lineItems[MENUS_PRODUCT_TYPE]) {
            continue;
         }

         if (Object.keys(state.summary.lineItems[MENUS_PRODUCT_TYPE]).length) {
            if(state.summary.lineItems[MENUS_PRODUCT_TYPE].taxRates == undefined) {
               if(window.Sentry) {
                  console.log(window.mymy.cart.summary.addOnLoad)
                  Sentry.captureMessage("MENUS_PRODUCT_TYPE TaxRates not defined")
               }
            }
            let ts = state.summary.lineItems[MENUS_PRODUCT_TYPE].taxRates.slice(0)
            ts.push(taxRate);
            taxRate = Math.max(...ts)
            let discount = 0
            if(discounts[state.summary.lineItems[MENUS_PRODUCT_TYPE].lineItemId]) {
               const discountItem = discounts[state.summary.lineItems[MENUS_PRODUCT_TYPE].lineItemId]
               discount += discountItem.price.gross * discountItem.quantity
            }
            untaxedItems.push((state.summary.lineItems[MENUS_PRODUCT_TYPE].price.gross * state.summary.lineItems[MENUS_PRODUCT_TYPE].quantity) + discount)
         }

         continue;
      }

      let lineItems = state.summary.lineItems[productType];
      if (Object.keys(lineItems).length < 1) {
         continue;
      }

      for (let slug in lineItems) {
         let ts = lineItems[slug].taxRates.slice(0)
         ts.push(taxRate);
         taxRate = Math.max(...ts)
         let discount = 0
         if(discounts[lineItems[slug].lineItemId]) {
            const discountItem = discounts[lineItems[slug].lineItemId]
            discount += discountItem.price.gross * discountItem.quantity
         }
         untaxedItems.push((lineItems[slug].price.gross * lineItems[slug].quantity) + discount)
      }
   }

   // add up the adjustments' totals
   for (let adjuster of state.summary.adjustments[SHIPPING_ADJUSTER_TYPE]) {
      totalTax += Math.round(adjuster.price.gross * adjuster.quantity * taxRate);
   }

   untaxedItems.forEach( itemPrice => {
      totalTax += Math.round(itemPrice * taxRate);
   })

   for(const taxType in state.summary.tax) {
      const taxObj = state.summary.tax[taxType]
      if(taxObj.rate == taxRate) {
         const title = 'calculated-tax';
         state.summary.tax[taxType].total += (totalTax/100)
         let tax = getSummaryItemObject(TAX_ADJUSTER_TYPE, {
            amount: (totalTax/100),
            description: title,
            type: TAX_ADJUSTER_TYPE
         });
         window.mymy.cart.summary.adjustments[TAX_ADJUSTER_TYPE].push({...tax});
         state.summary.adjustments[TAX_ADJUSTER_TYPE].push({...tax});
      }
   }
}

export default {
   /**
    * Add data from the template into the Vuex store.
    *
    * @param state {object}
    */
   initTemplateStoreData(state) {

      // default values for the 'cart' object (before the customer's cart data gets added)
      if (typeof window.mymy.cart === 'object') {

         // add the menu as a line item to the summary
         if (window.mymy.cart.summary.addOnLoad.menu !== null) {
            state.summary.lineItems.menus = {...window.mymy.cart.summary.addOnLoad.menu};
         }

         // add the default shipping fee and tax data
         state.summary.adjustments.shipping.push({...window.mymy.cart.summary.addOnLoad.shipping});
         Vue.set(state.summary.adjustments, TAX_ADJUSTER_TYPE, []);
         state.summary.tax = {...window.mymy.cart.summary.tax};


         // general data about the cart
         state.summary.showNetAmounts = window.mymy.cart.summary.showNetAmounts;
         state.cart.numberOfPeople = window.mymy.cart.numberOfPeople;
         state.cart.currency = window.mymy.cart.currency;
         state.cart.language = window.mymy.cart.language;
         state.cart.country = window.mymy.cart.country;
         state.cart.relatedSite = window.mymy.cart.relatedSite;

         // cast these arrays back into objects since Twig's json_encode('JSON_FORCE_OBJECT')
         // doesn't affect child objects
         window.mymy.cart.summary.lineItems.accessories = {};
         window.mymy.cart.summary.lineItems.dishes = {};
         window.mymy.cart.summary.lineItems.drinks = {};

         // cast each course section's arrays to objects
         for (const menuSectionId in window.mymy.cart.summary.courseItems) {
            window.mymy.cart.summary.courseItems[menuSectionId] = {};
            try {
               Vue.set(state.summary.courseItems, menuSectionId, {});
            }
            catch (e) {
               if(window.Sentry) {
                  Sentry.captureException(e);
               }
               console.error(e);
            }
         }
      }

      // the selected menu or menu the customer is currently viewing
      if (typeof window.mymy.menu === 'object') {
         state.menu.id = window.mymy.menu.id;
         state.menu.title = window.mymy.menu.title;
         state.menu.variantId = window.mymy.menu.variantId;
         state.menu.isALaCarte = window.mymy.menu.isALaCarte;
         state.menu.isShippable = window.mymy.menu.isShippable;
         state.menu.minimumOrderValue = window.mymy.menu.minimumOrderValue;
         state.menu.minimumPreparationDays = window.mymy.menu.minimumPreparationDays;
      }

      calculateTaxes(state);
   },

   /**
    * Update the store's data with data saved in the "menuCookie".
    *
    * @param state
    * @param cookie
    */
   initMenuCookieStoreData(state, cookie) {

      // check the number of people
      let numberOfPeople = cookie.q ?? window.mymy.menu.quantity.min;
      if (
         typeof numberOfPeople === 'number' &&
         numberOfPeople > window.mymy.menu.quantity.min &&
         numberOfPeople < window.mymy.menu.quantity.max
      ) {
         state.cart.numberOfPeople = window.mymy.cart.numberOfPeople = numberOfPeople;

         // keep the menu line item's quantity synced until the customer's cart data loads
         if (state.summary.lineItems.menus !== null) {
            state.summary.lineItems.menus.quantity = numberOfPeople;
         }
      }

      // check the delivery date
      let deliveryDate = cookie.d ?? null;
      if (typeof deliveryDate === 'string' && deliveryDate) {
         state.cart.deliveryDate = window.mymy.cart.deliveryDate = deliveryDate;
      }
   },

   /**
    * Add data coming back from an async call to Commerce's controller for the customer's cart.
    *
    * @param state {object}
    * @param cart {object}
    */
   initCartStoreData(state, cart) {
      state.cart.number = window.mymy.cart.number = cart.number;
      state.cart.shortNumber = window.mymy.cart.shortNumber = cart.shortNumber;
      state.cart.email = window.mymy.cart.email = cart.email;
      state.cart.isBusinessCustomer = window.mymy.cart.isBusinessCustomer = cart.isBusinessCustomer;
      state.cart.gatewayId = window.mymy.cart.gatewayId = cart.gatewayId;
      state.cart.couponCode = window.mymy.cart.couponCode = cart.couponCode;
      state.cart.shippingMethod.name = window.mymy.cart.shippingMethod.name = cart.shippingMethodName;
      state.cart.shippingMethod.handle = window.mymy.cart.shippingMethod.handle = cart.shippingMethodHandle;

      // since we're adding dynamic data from the cart, remove any original static data that was
      // set during the `initTemplateStoreData` method above.
      /** @see initTemplateStoreData **/
      // Vue.set(state.summary.adjustments, SHIPPING_ADJUSTER_TYPE, []);
      Vue.set(state.summary.adjustments, DISCOUNT_ADJUSTER_TYPE, []);
      Vue.set(state.summary.adjustments, TAX_ADJUSTER_TYPE, []);

      // take note of the menu's variant ID (if it's a "package menu")
      const menuPurchasableId = window.mymy.menu.isALaCarte ? null : window.mymy.menu.variantId;

      // update our MenuItemControl.vue components with line item data if they already existed
      // on the cart (this doesn't include the menu).
      for (const lineItem of cart.lineItems) {
         const purchasableId = parseInt(lineItem.snapshot.purchasableId);

         // add any discounts that this line item might have
         for (const adjustment of lineItem.adjustments) {
            if (adjustment.type === DISCOUNT_ADJUSTER_TYPE && ! adjustment.included) {
               let discount = getSummaryItemObject(DISCOUNT_ADJUSTER_TYPE, adjustment);
               window.mymy.cart.summary.adjustments[DISCOUNT_ADJUSTER_TYPE].push({...discount});
               state.summary.adjustments[DISCOUNT_ADJUSTER_TYPE].push({...discount});
            }
         }

         // handle the menu's line item differently than below
         if (menuPurchasableId === purchasableId) {
            console.log('MENU: ' + lineItem.description, lineItem.qty);
            state.summary.lineItems.menus.lineItemId = lineItem.id;
            state.summary.lineItems.menus.quantity = lineItem.qty;
            window.mymy.cart.summary.lineItems.menus = {...state.summary.lineItems.menus};
            continue;
         }


         // find this line item in the menu's list of MenuItemControl components and update its data
         for (const key in state.menu.items) {
            if (state.menu.items[key].variant.id !== purchasableId) {
               continue;
            }

            let MenuItemControls = state.menu.items[key];
            MenuItemControls.lineItemId = lineItem.id;
            MenuItemControls.quantity = lineItem.qty;

            // update our copy of the summary on the window
            window.mymy.cart.summary.lineItems[MenuItemControls.product.type][MenuItemControls.id] = getSummaryItemObject(
               MenuItemControls.product.type,
               MenuItemControls
            );
            break;
         }
      }


      // update all selected course items (for package menus only)
      for (const course of cart.mymy.menuCoursesSnapshot) {
         // loop through the array of variant IDs selected for this course
         for (const variantId of course.variants) {
            // loop through all menu items and update their `courseDishQuantity` property
            for (const key in state.menu.items) {
               if (state.menu.items[key].isInCourseSection &&
                  state.menu.items[key].variant.id === variantId &&
                  state.menu.items[key].courseCategory.id === course.courseCategoryId
               ) {
                  let MenuItemControls = state.menu.items[key];

                  try {
                     MenuItemControls.courseDishQuantity = state.summary.lineItems.menus.quantity;
                  }
                  catch (e) {
                     MenuItemControls.courseDishQuantity = cart.numberOfPeople;
                     if(window.Sentry) {
                        Sentry.captureException(e);
                     }
                     console.error(e);
                  }

                  // update our copy of the summary on the window
                  window.mymy.cart.summary.courseItems[MenuItemControls.courseCategory.slug][MenuItemControls.id] = getSummaryItemObject(
                     MenuItemControls.product.type,
                     MenuItemControls
                  );
                  break;
               }
            }
         }
      }

      // add any discounts that affect the order as a whole
      for (const adjustment of cart.orderAdjustments) {
         if (adjustment.type === DISCOUNT_ADJUSTER_TYPE && ! adjustment.included) {
            let discount = getSummaryItemObject(adjustment.type, adjustment);
            window.mymy.cart.summary.adjustments[adjustment.type].push({...discount});
            state.summary.adjustments[adjustment.type].push({...discount});
         }
      }

      // add the cart's `deliveryDate`
      if (typeof cart.deliveryDate === 'object' && cart.deliveryDate !== null) {
         let deliveryDate = cart.deliveryDate.date ?? null;
         if (typeof deliveryDate === 'string') {
            state.cart.deliveryDate = window.mymy.cart.deliveryDate = deliveryDate;
         }
      }

      // add the cart's `numberOfPeople`
      let numberOfPeople = cart.numberOfPeople ?? window.mymy.menu.quantity.min;
      state.cart.numberOfPeople = window.mymy.cart.numberOfPeople = numberOfPeople;

      // `specialWishes` field
      if (typeof cart.specialWishes === 'string') {
         state.cart.specialWishes = window.mymy.cart.specialWishes = cart.specialWishes.replace(/(?:\r\n|\r|\n)/g, '<br>');
      }

      // `occasion` field
      try {
         state.cart.occasion = window.mymy.cart.occasion = window.mymy.translations.fields.occasion[cart.occasion.value];
      }
      catch (e) {
         if(window.Sentry) {
            Sentry.captureException(e);
         }
         console.error(e);
      }

      calculateTaxes(state);
      // lock the cart data that's on the window so we have a snapshot of original data before
      // anything was modified by the customer.
      window.mymy.cart = window.mymy.deepFreeze(window.mymy.cart, true);
   },

   /**
    * Set payment gateway.
    *
    * @param state {object}
    * @param gatewayId {int}
    */
   setCartPaymentGateway(state, gatewayId) {
      state.cart.gatewayId = gatewayId;
   },

   /**
    * Add a menu's section to the Vuex store.
    *
    * @param state {object}
    * @param MenuSection {object}
    * @see @/js/funnel/_components/menu/MenuSection.vue
    */
   addMenuSectionToStore(state, MenuSection) {
      // add the section's data
      try {
         Vue.set(state.menu.sections, MenuSection.index, MenuSection);
      }
      catch (e) {
         if(window.Sentry) {
            Sentry.captureException(e);
         }
         console.error(e);
      }

      // if it's a course, add a copy in the `courses` object
      if (MenuSection.isForCourseDishes) {
         try {
            Vue.set(state.menu.courses, MenuSection.index, MenuSection);
         }
         catch (e) {
            if(window.Sentry) {
               Sentry.captureException(e);
            }
            console.error(e);
         }
      }
   },

   /**
    * Add a menu item to the Vuex store.
    *
    * @param state {object}
    * @param MenuItemControls {object}
    * @see @/js/funnel/_components/menu/MenuItemControls.vue
    */
   addMenuItemToStore(state, MenuItemControls) {
      try {
         Vue.set(state.menu.items, MenuItemControls.id, MenuItemControls);
      }
      catch (e) {
         if(window.Sentry) {
            Sentry.captureException(e);
         }
         console.error(e);
      }
   },

   /**
    * Change from one section of a menu to another.
    *
    * A section would be something like courses, drinks, accessories, etc, that the customer
    * changes through on the Selection page. The index is 0-based and corresponds to the
    * Bootstrap-Vue tab that each menu section is hidden in. Changing this number effectively
    * changes the tab that's visible to the customer.
    *
    * If you're calling this somewhere on the Selection page, use its local `goToSection()`
    * method instead where possible. This mutation is simply to adjust the state.
    *
    * @param state {object}
    * @param index {integer}
    */
   goToMenuSection(state, index) {
      state.menu.sectionIndex = parseInt(index);
   },

   /**
    * Update specific custom field data that might exist in the store.
    *
    * @param state {object}
    * @param data {{field: String, value: String|Number|Object}}
    */
   updateCustomField(state, data) {
      if (! data.value || ! data.field) {
         return;
      }

      try {
         switch (data.field) {
            case CUSTOM_FIELD_HANDLE_NUMBER_OF_PEOPLE:
               state.cart.numberOfPeople = data.value;
               break;
            case CUSTOM_FIELD_HANDLE_DELIVERY_DATE:
               state.cart.deliveryDate = data.value;
               break;
         }
      }
      catch (e) {
         if(window.Sentry) {
            Sentry.captureException(e);
         }
         console.error(e);
      }
   },

   /**
    * Add a dish to the summary's course items object (for package menus only).
    *
    * @param state
    * @param MenuItemControls {object}
    * @see @/js/funnel/_components/menu/MenuItemControls.vue
    */
   addCourseItem(state, MenuItemControls) {
      try {
         if (typeof state.summary.courseItems[MenuItemControls.courseCategory.slug] !== 'undefined') {
            Vue.set(
               state.summary.courseItems[MenuItemControls.courseCategory.slug],
               MenuItemControls.id,
               getSummaryItemObject(MenuItemControls.product.type, MenuItemControls)
            );
         }
      }
      catch (e) {
         if(window.Sentry) {
            Sentry.captureException(e);
         }
         console.error(e);
      }
   },

   /**
    * Remove a dish from the summary's course items object (for package menus only).
    *
    * @param state {object}
    * @param MenuItemControls {object}
    * @see @/js/funnel/_components/menu/MenuItemControls.vue
    */
   removeCourseItem(state, MenuItemControls) {
      try {
         if (typeof state.summary.courseItems[MenuItemControls.courseCategory.slug] !== 'undefined') {
            Vue.delete(
               state.summary.courseItems[MenuItemControls.courseCategory.slug],
               MenuItemControls.id,
            );
         }
      }
      catch (e) {
         if(window.Sentry) {
            Sentry.captureException(e);
         }
         console.error(e);
      }
   },

   /**
    * Update a given line item in our store's state because its quantity has changed to
    * something above 0.
    *
    * @param state {object}
    * @param MenuItemControls {object}
    * @see @/js/funnel/_components/menu/MenuItemControls.vue
    */
   updateLineItem(state, MenuItemControls) {
      try {
         Vue.set(
            state.summary.lineItems[MenuItemControls.product.type],
            MenuItemControls.id,
            getSummaryItemObject(MenuItemControls.product.type, MenuItemControls)
         );

         const itemKey = [MenuItemControls.product.type, 'line-item', MenuItemControls.slug].join('-')
         if(!state.summary.lineItemsFlattened.includes(itemKey)) {
            state.summary.lineItemsFlattened.push(itemKey)
         }

         calculateTaxes(state);
      }
      catch (e) {
         if(window.Sentry) {
            Sentry.captureException(e);
         }
         console.error(e);
      }
   },

   /**
    * Remove a given line item in our store's state because its quantity has reached 0.
    *
    * @param state {object}
    * @param MenuItemControls {object}
    * @see @/js/funnel/_components/menu/MenuItemControls.vue
    */
   removeLineItem(state, MenuItemControls) {
      try {
         Vue.delete(
            state.summary.lineItems[MenuItemControls.product.type],
            MenuItemControls.id
         );

         const itemKey = [MenuItemControls.product.type, 'line-item', MenuItemControls.slug].join('-')
         if(state.summary.lineItemsFlattened.includes(itemKey)) {
            state.summary.lineItemsFlattened.splice(state.summary.lineItemsFlattened.indexOf(itemKey), 1)
         }

         calculateTaxes(state);
      }
      catch (e) {
         if(window.Sentry) {
            Sentry.captureException(e);
         }
         console.error(e);
      }
   },

   /**
    * Update the quantity of the menu's line item object in the state's summary.
    *
    * @param state {*}
    * @param quantity {Number}
    */
   updateMenuLineItemQuantity(state, quantity) {
      // change the quantity
      try {
         state.summary.lineItems.menus.quantity = quantity;
         calculateTaxes(state);
      } catch (e) {
         if(window.Sentry) {
            Sentry.captureException(e);
         }
         console.error(e);
      }
   },

   /**
    * Set the MenuItemControls.vue component that is being focused on.
    *
    * This is necessary to populate the data in the `menu-item-details-modal` when it opens
    * to show the customer details about the MenuItemControls they clicked on.
    *
    * @param state {object}
    * @param MenuItemControls <MenuItemControls>
    */
   setFocusedMenuItem(state, MenuItemControls) {
      state.focusedMenuItem = MenuItemControls;
   },

   /**
    * Set the menu that the customer selected on the menus listing page. A "selected" menu is
    * one that was involved with a successful pass during the Availability Check. If the check
    * failed, the menu the customer clicked should not be set as the selected menu.
    *
    * @param state {object}
    * @param menuDataObject {object}
    */
   setSelectedMenu(state, menuDataObject) {
      state.availability.selectedMenu = menuDataObject;
   },

   /**
    * Set the menu that the customer currently clicked on and will use to run the Availability
    * Check. This menu is temporary and will only become the "selected" menu if there is caterer
    * availability from the criteria the customer provided (address, menu, delivery date, etc).
    *
    * @param state {object}
    * @param menuDataObject {object}
    */
   setFocusedMenu(state, menuDataObject) {
      state.availability.focusedMenu = menuDataObject;
   },

   /**
    * Update anything in the `cart` object that might have changed since loading the page.
    *
    * @param state {object}
    * @param data {{number: string, shortNumber: string }}
    */
   updateCartData(state, data) {
      // the full cart number
      if (typeof data.number === 'string' && data.number) {
         state.cart.number = data.number;
      }

      // the cart's abbreviated number
      if (typeof data.shortNumber === 'string' && data.shortNumber) {
         state.cart.shortNumber = data.shortNumber;
      }
   },

   isCartDataLoaded(state, loaded) {
      state.isCartDataLoaded = loaded;
   }
}